// LIBRERIE/IMPORTS
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const BannerVendi: React.FC = () => {
    const { t } = useTranslation();

    return (
        <section id="valutazione" className="space-ptb">
            <div className="container-fluid">
                <div className="row align-items-center">
                    <div className="col-12 col-lg-6">
                        <div className="position-relative">
                            <h2 className="mb-4" dangerouslySetInnerHTML={{ __html: t('homePage.sellBanner.title') as string }} />
                            <img className="img-fluid img-border mb-4 mb-lg-0" src="/assets/images/inHome/valutazione.webp" alt={t('homePage.sellBanner.imgAlt') as string}/>
                        </div>
                    </div>
                    <div className="col-12 div col-lg-6">
                        <p dangerouslySetInnerHTML={{ __html: t('homePage.sellBanner.para1') as string }} />
                        <p dangerouslySetInnerHTML={{ __html: t('homePage.sellBanner.para2') as string }} />
                        <p className="mb-2">{t('homePage.sellBanner.para3')}</p>
                        <Link className="mb-4 btn btn-primary" to="/valutazione" title={t('homePage.sellBanner.linkAlt') as string}>
                            {t('homePage.sellBanner.linkValuta')}
                        </Link>
                        <p className="mb-2">{t('homePage.sellBanner.para4')}</p>
                        <Link className="btn btn-primary" to="/cerca" title={t('homePage.sellBanner.linkAlt') as string}>
                            {t('homePage.sellBanner.linkCerca')}
                        </Link>
                        <img className="d-none d-xl-block" src="/assets/images/logoSmall.png" alt="logo"/>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default BannerVendi;